import { render, staticRenderFns } from "./ReplyTable.vue?vue&type=template&id=2fc48196"
import script from "./ReplyTable.vue?vue&type=script&lang=js"
export * from "./ReplyTable.vue?vue&type=script&lang=js"
import style0 from "./ReplyTable.vue?vue&type=style&index=0&id=2fc48196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports